module.exports = __webpack_public_path__ + "static/media/carro.94a6149d.png";